import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SupportPersonResponseModel } from 'data/supportPerson/supportPerson.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: SupportPersonResponseModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<SupportPersonResponseModel[]>> = (
  _,
  action,
) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const supportPersonSlice = createSlice({
  name: 'supportPerson',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default supportPersonSlice;
